import { useEffect } from 'react';
import { useKoordinatorI18n } from '../i18n/KoordinatorI18nProvider';

/**
 * Keep document language aligned with Koordinator platform UI locale.
 *
 * The legacy filename is retained to keep this focused correction free from
 * route churn. BrandStore regional locale must not control document language.
 */
export const BrandStoreLocaleExperienceSync: React.FC = () => {
  const { locale } = useKoordinatorI18n();

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const root = document.documentElement;
    const previousLanguage = root.lang;
    root.lang = locale;

    return () => {
      root.lang = previousLanguage || 'en-US';
    };
  }, [locale]);

  return null;
};
